import React from 'react';

import DeviceDetailsBottomContainer from './DeviceDetailsBottomContainer';
import DeviceDetailsTopContainer from './DeviceDetailsTopContainer';

/**
 * Component to display the device details page
 * @returns {any} The result
 */
function DeviceDetails() {
  return (
    <div className="device-devices-wrap">
      <div className="device-details-container-1">
        <DeviceDetailsTopContainer />
      </div>
      <div className="device-details-container-2">
        <DeviceDetailsBottomContainer />
      </div>
    </div>
  );
}

export default DeviceDetails;
